(function () {
  var el = document.getElementById('NewsletterPopup');
  if (!el) return;

  var delay = (parseInt(el.getAttribute('data-delay'), 10) || 20) * 1000;
  var days = parseInt(el.getAttribute('data-days'), 10) || 1;
  var KEY = 'merenus_np_seen_at';
  var DAY = 86400000;

  function seenRecently() {
    try {
      var v = window.localStorage.getItem(KEY);
      if (!v) return false;
      var t = new Date(v).getTime();
      if (isNaN(t)) return false;
      return (Date.now() - t) < days * DAY;
    } catch (e) {
      return false;
    }
  }

  function markSeen() {
    try {
      window.localStorage.setItem(KEY, new Date().toISOString());
    } catch (e) {}
  }

  function open() {
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('np-open');
    var input = el.querySelector('.np__input');
    if (input) input.focus();
  }

  function close() {
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('np-open');
    markSeen();
  }

  if (!seenRecently()) {
    window.setTimeout(open, delay);
  }

  el.addEventListener('click', function (e) {
    if (e.target.closest('[data-np-close]')) {
      e.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && el.classList.contains('is-open')) close();
  });

  var form = el.querySelector('[data-np-form]');
  if (!form) return;
  var input = form.querySelector('.np__input');
  var success = el.querySelector('[data-np-success]');
  var error = el.querySelector('[data-np-error]');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = (input.value || '').trim();
    if (!email || email.indexOf('@') === -1) {
      if (error) error.hidden = false;
      return;
    }
    if (error) error.hidden = true;

    var btn = form.querySelector('.np__btn');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Sending...';
    }

    var body = 'form_type=customer&utf8=%E2%9C%93&contact%5Btags%5D=newsletter&contact%5Bemail%5D=' + encodeURIComponent(email);

    fetch('/contact?form_type=customer', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body
    })
      .then(function () {
        form.hidden = true;
        if (success) success.hidden = false;
        markSeen();
      })
      .catch(function () {
        form.hidden = true;
        if (success) success.hidden = false;
        markSeen();
      });
  });

  var copyBtn = el.querySelector('[data-np-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = copyBtn.getAttribute('data-code') || '';
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code);
        }
      } catch (e) {}
      copyBtn.textContent = 'Copied';
    });
  }
})();
